import { InvestorDetailsLegalEntityAssetClassTargetsQuery } from '@/__generated__/graphql';
import { InvestorDetailsEntityTypeEnum } from '@/components/investors-page/investorDetailsPage/types';
import NoResults from '@/components/table/noResults';
import SummaryTableRow from './tableRow';

interface SummaryTableBodyProps {
  investorSummaryRows: InvestorDetailsLegalEntityAssetClassTargetsQuery['legalEntity']['assetClassTargets'];
  ignoreAllocationTargets: boolean;
  targetSubAssetClasses: boolean;
  commitmentPlansTotal: number | null;
  targetOCRatio: number | null;
  entityType: InvestorDetailsEntityTypeEnum;
  expandedRows: Record<string, boolean>;
  setExpandedRows: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

const SummaryTableBody = ({
  investorSummaryRows,
  ignoreAllocationTargets,
  targetSubAssetClasses,
  commitmentPlansTotal,
  targetOCRatio,
  entityType,
  expandedRows,
  setExpandedRows
}: SummaryTableBodyProps) => {
  const handleToggleRowExpanded = (rowId: string) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  if (!investorSummaryRows?.length) {
    return <NoResults />;
  }

  return (
    <>
      {investorSummaryRows.map((row) => (
        <SummaryTableRow
          key={row.id}
          row={row}
          ignoreAllocationTargets={ignoreAllocationTargets}
          targetSubAssetClasses={targetSubAssetClasses}
          commitmentPlansTotal={commitmentPlansTotal}
          targetOCRatio={targetOCRatio}
          entityType={entityType}
          isExpanded={expandedRows?.[row.id] ?? false}
          onToggleExpanded={() => handleToggleRowExpanded(row.id)}
        />
      ))}
    </>
  );
};

export default SummaryTableBody;
